import { render, staticRenderFns } from "./FaleConosco.vue?vue&type=template&id=03db8faa&scoped=true&"
import script from "./FaleConosco.vue?vue&type=script&lang=js&"
export * from "./FaleConosco.vue?vue&type=script&lang=js&"
import style0 from "./FaleConosco.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FaleConosco.vue?vue&type=style&index=1&id=03db8faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03db8faa",
  null
  
)

export default component.exports